import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import PostApiCall from "./Api";
export default function GetSeoData({ type, id }) {
    const [seoData, setSeoData] = useState([]);
    useEffect(() => {
        fetchSeoData();
    }, [window.location.pathname]);
    const fetchSeoData = () => {
        let whereclause = id == null ? `where fld_type = '${type}'` : `where fld_type = '${type}' and fld_id = ${id}`
        PostApiCall.postRequest(
            {
                whereClause: whereclause
            },
            "GetSEOData"
        ).then((results) =>
            results.json().then((obj1) => {
                if (results.status == 200 || results.status == 201) {
                    setSeoData(obj1.data[0]);
                }
            })
        );
    };
    return (
        <div>
            <Helmet>
                <title>{seoData?.fld_meta_tile}</title>
                <meta name="description" content={seoData?.fld_meta_description} />
            </Helmet>
        </div>
    );
}
